import React, { createContext, useContext, useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import AuthService from '../services/authService';

const AuthContext = createContext();

export function useAuth() {
  return useContext(AuthContext);
}

export function AuthProvider({ children }) {
  const [currentUser, setCurrentUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();


  // Login
  const login = async (username, password) => {
    try {
      // Test user uchun
      if (username.toLowerCase() === 'davron' && password === '1234') {
        const testUser = {
          token: 'test-token-1234',
          user: {
            id: '1',
            username: 'davron',
            name: 'Davron',
            email: 'davron@example.com'
          }
        };
        localStorage.setItem('token', testUser.token);
        localStorage.setItem('user', JSON.stringify(testUser.user));
        setCurrentUser(testUser.user);
        navigate('/dashboard');
        return;
      }

      // Boshqa userlar uchun API ga borib tekshirish
      const response = await AuthService.login({ username, password });
      localStorage.setItem('token', response.data.token);
      localStorage.setItem('user', JSON.stringify(response.data));
      setCurrentUser(response.data);
      navigate('/dashboard');
    } catch (error) {
      throw error;
    }
  };

  // Register
  const register = async (userData) => {
    try {
      const response = await AuthService.register(userData);
      localStorage.setItem('token', response.token);
      localStorage.setItem('user', JSON.stringify(response.user));
      setCurrentUser(response.user);
      navigate('/dashboard');
    } catch (error) {
      throw error;
    }
  };

  // Logout
  const logout = () => {
    try {
      const token = localStorage.getItem('token');
      if (token === 'test-token-1234') {
        localStorage.removeItem('token');
        localStorage.removeItem('user');
        setCurrentUser(null);
        return;
      }

      // Boshqa userlar uchun API logout
      AuthService.logout()
        .then(() => {
          localStorage.removeItem('token');
          localStorage.removeItem('user');
          setCurrentUser(null);
        })
        .catch(error => {
          console.error('Logout xatoligi:', error);
          localStorage.removeItem('token');
          localStorage.removeItem('user');
          setCurrentUser(null);
        });
    } catch (error) {
      console.error('Logout xatoligi:', error);
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      setCurrentUser(null);
    } finally {
      navigate('/login');
    }
  };

  // Get current user
  const getCurrentUser = async () => {
    try {
      const user = await AuthService.getCurrentUser();
      setCurrentUser(user);
      return user;
    } catch (error) {
      throw error;
    }
  };

  // Check authentication status
  useEffect(() => {
    const token = localStorage.getItem('token');
    const user = localStorage.getItem('user');

    if (token && user) {
      setCurrentUser(JSON.parse(user));
    }

    setLoading(false);
  }, []);

  const value = {
    currentUser,
    loading,
    login,
    register,
    logout,
    getCurrentUser,
  };

  return (
    <AuthContext.Provider value={value}>
      {!loading && children}
    </AuthContext.Provider>
  );
}
